import React from "react";
import { Shield, Lock, Phone } from "lucide-react";

const TrustBadges = ({ className = "" }) => {
  return (
    <div className={`flex flex-wrap items-center justify-center gap-3 ${className}`}>
      <div className="flex items-center gap-1.5 bg-slate-100 rounded-full px-3 py-1.5 text-xs font-semibold text-slate-700">
        <Phone size={12} className="text-red-600" />
        112 India Integration
      </div>
      <div className="flex items-center gap-1.5 bg-slate-100 rounded-full px-3 py-1.5 text-xs font-semibold text-slate-700">
        <Lock size={12} className="text-emerald-600" />
        DPDPA 2023 Compliant
      </div>
      <div className="flex items-center gap-1.5 bg-slate-100 rounded-full px-3 py-1.5 text-xs font-semibold text-slate-700">
        <Shield size={12} className="text-blue-600" />
        AES-256 Encrypted
      </div>
    </div>
  );
};

export default TrustBadges;
